import { Button, Col, Container, Row } from "reactstrap";

function HeroSection() {
  return (
    <Container className="hero-container d-flex flex-column align-items-center justify-content-center text-center">
      <Row className="w-100">
        <Col>
          <h1 className="fw-bold display-4 hero-main-heading">
            Transforming Businesses with<br />
            <span className="brand-gradient-text">
              Custom CAD & AI Solutions
            </span>
          </h1>
          <div className="hero-desc">
            {/* <b className="brand-text" style={{ fontWeight: 600 }}>
              
            </b>{" "} */}
            Wocons
            helps businesses automate workflows and implement cutting-edge AI
            solutions tailored to your specific needs.
          </div>

          {/* Action Buttons */}
          <div className="d-flex justify-content-center mt-4 gap-3">
            <Button
              className="explore-btn fw-semibold px-4"
              color="primary"
              style={{
                background: "linear-gradient(90deg,#4175fc 0%,#9159f4 100%)",
                border: "none",
              }}
            >
              <a href="#contact-section" className="quote-btn1">
               Request a Consultation

              </a>
            </Button>
            
          </div>

          {/* Project Showcase */}
          {/* <div className="mt-5">
            <span className="fw-semibold me-2">Featured Project:</span>
            <a
              href="https://appspro.in"
              target="_blank"
              rel="noopener noreferrer"
              className="project-link"
              style={{
                fontWeight: "600",
                color: "#4175fc",
                textDecoration: "none",
              }}
            >
              Task Manager
            </a>
          </div> */}
        </Col>
      </Row>
    </Container>
  );
}

export default HeroSection;
